export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "collection_items_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収できるもの"])}
    }
  })
}
